import { render } from "./ManagerBase.vue?vue&type=template&id=452cd62c"
import script from "./ManagerBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerBase.vue?vue&type=script&setup=true&lang=js"

import "./ManagerBase.vue?vue&type=style&index=0&id=452cd62c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tools/ManagerBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "452cd62c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('452cd62c', __exports__)) {
    api.reload('452cd62c', __exports__)
  }
  
  module.hot.accept("./ManagerBase.vue?vue&type=template&id=452cd62c", () => {
    api.rerender('452cd62c', render)
  })

}


export default __exports__